/**
 * Main layout segment.
 *
 * @see AppView
 */
const Main = ({ children }) => {
  return <main>{children}</main>
}

export default Main
